import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import createFormDataArrOfAttachments from '../helpers/createFormDataArrOfAttachments';
import updateComment from '../requests/updateRequestComment';
import addAttachmentsToComment from '../requests/addAttachmentsToRequestComment';

const useSendEditedRequestComment = (editedCommentData) => {
  const queryClient = useQueryClient();

  const sendEditedComment = useCallback(
    async ({ attachments, comment }) => {
      const commentId = editedCommentData.id;

      const newAttachments = attachments.filter(
        (attachment) => attachment instanceof File
      );

      const oldAttachments = attachments.reduce((filtered, attachment) => {
        if (!(attachment instanceof File)) {
          filtered.push(attachment.id);
        }
        return filtered;
      }, []);

      const newAttachmentsFormData =
        createFormDataArrOfAttachments(newAttachments);

      await updateComment({
        noteId: commentId,
        note: comment,
        attachmentIds: oldAttachments,
      });

      if (newAttachments.length) {
        await addAttachmentsToComment(
          editedCommentData.id,
          newAttachmentsFormData
        );

        if (editedCommentData.hasAttachment === false) {
          await queryClient.refetchQueries(
            [`commentAttachments`, editedCommentData.id],
            { active: false }
          );
        }
      }

      if (editedCommentData.hasAttachment === true) {
        queryClient.invalidateQueries([
          `commentAttachments`,
          editedCommentData.id,
        ]);
      }
    },
    [editedCommentData, queryClient]
  );

  return sendEditedComment;
};

export default useSendEditedRequestComment;
